import { ThunkDispatch } from "redux-thunk";

import { connect } from 'react-redux';

import { hideGenericDialog, Action } from '../actions';
import { getGenericDialogState, getLocale, State } from '../reducers';

import GenericDialogView from '../components/GenericDialogView';
import { getTranslation } from "../services/translation-store";

interface StateProps {
    readonly open: boolean,
    readonly title: string,
    readonly text: string,
}

interface DispatchProps {
    readonly onDialogClose: () => void,
}


const mapStateToProps = (state: State): StateProps => {
    const locale = getLocale(state);
    const { open, title, text } = getGenericDialogState(state);
    return {
        open,
        title,
        text: getTranslation(locale, text),
    };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<State, any, Action>): DispatchProps => (
    {
        onDialogClose: () => {
            dispatch(hideGenericDialog());
        },
    }
);

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(GenericDialogView);



// WEBPACK FOOTER //
// ./src/containers/GenericDialog.ts